import React, { FC, ReactNode } from 'react'
import {
  Flex,
  StackProps,
  TextProps,
  VStack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  IconButton,
} from '@chakra-ui/react'
import { InfoOutlineIcon } from '@chakra-ui/icons'

import { Text } from '../../typography/Text'

export type LabelProps = {
  label: ReactNode
  subtitle?: ReactNode
  helperText?: ReactNode
  htmlFor?: string
  size?: TextProps['size']
} & Omit<StackProps, 'children'>

export const Label: FC<LabelProps> = ({
  subtitle,
  helperText,
  label,
  htmlFor,
  size = ['md', 'sm'],
  ...props
}) => {
  const labelText = (
    <Text size={size} as="label" htmlFor={htmlFor}>
      {label}
    </Text>
  )

  return (
    <VStack alignItems="flex-start" spacing="sm" {...props}>
      <Flex justifyContent="space-between" alignItems="center">
        {helperText ? (
          <span>
            {labelText}
            <Popover>
              <PopoverTrigger>
                <IconButton
                  aria-label="View helper text"
                  variant="unstyled"
                  mx="xs"
                  size="xxxs"
                  icon={<InfoOutlineIcon />}
                />
              </PopoverTrigger>
              <PopoverContent
                bg="softBlack"
                color="softWhite"
                fontFamily="mono"
                fontSize="xs"
                letterSpacing="tight"
                maxWidth="prose"
                padding="sm"
              >
                <PopoverArrow bg="softBlack" />
                <PopoverBody>{helperText}</PopoverBody>
              </PopoverContent>
            </Popover>
          </span>
        ) : (
          labelText
        )}
      </Flex>

      {subtitle ? <Text size="xs">{subtitle}</Text> : null}
    </VStack>
  )
}
